module.exports = __webpack_public_path__ + "img/quickresume7.bc8e6ad0.png";